define("settings/engine", ["exports", "ember-engines/engine", "ember-load-initializers", "settings/config/environment", "settings/resolver"], function (_exports, _engine, _emberLoadInitializers, _environment, _resolver) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-engines/engine",0,"ember-load-initializers",0,"settings/config/environment",0,"settings/resolver"eaimeta@70e063a35619d71f

  const {
    modulePrefix
  } = _environment.default;

  const Eng = _engine.default.extend({
    modulePrefix,
    Resolver: _resolver.default,
    dependencies: {
      services: ['ada', 'ada-campaigns', 'address', 'address-validation', 'alerts', 'auth', 'cancellation', 'cache', 'categorization-rewards', 'credential-status', 'credentials', 'dialogManager', 'errors', 'events', 'industry-data', 'instagram', 'integrationsQueue', 'intl', 'laterConfig', 'linkedin', 'locale', 'localStorageManager', 'onboarding', 'payment', 'perfect-scroll', 'performance-tracking', 'pinterest', 'plans', 'router', 'seamless-checkout-manager', 'segment', 'segmentEvents', 'session', 'social/facebook-auth', 'social/facebook-graph', 'social/instagram-business', 'social/connect-profiles', 'store', 'stripe', 'subscriptions', 'tiktok', 'twitter', 'userConfig', 'wistiaVideo'],
      externalRoutes: ['plans', 'plans.migrate', 'plans.plan', 'plans.current', 'cluster.schedule.calendar', 'user.trial_plans', 'user.forgot_email']
    }
  });

  (0, _emberLoadInitializers.default)(Eng, modulePrefix);
  var _default = Eng;
  _exports.default = _default;
});